import { render, staticRenderFns } from "./SubFooter.vue?vue&type=template&id=4fe6fefc&scoped=true&"
import script from "./SubFooter.vue?vue&type=script&lang=ts&"
export * from "./SubFooter.vue?vue&type=script&lang=ts&"
import style0 from "./SubFooter.vue?vue&type=style&index=0&id=4fe6fefc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe6fefc",
  null
  
)

export default component.exports